import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-87bab51a")

_pushScopeId("data-v-87bab51a")
const _hoisted_1 = {
  key: 0,
  class: "leave-item"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "r-grid container" }, [
  /*#__PURE__*/_createVNode("h2", null, "Leave Item")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("label", null, "Date", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("label", null, "Status", -1)
const _hoisted_5 = { class: "status" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Leave Type ")
const _hoisted_7 = {
  key: 0,
  class: "asterisk"
}
const _hoisted_8 = {
  key: 0,
  value: "workday"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Duration ")
const _hoisted_10 = {
  key: 0,
  class: "asterisk"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("option", { value: "full_day" }, "Full Day", -1)
const _hoisted_12 = {
  key: 0,
  value: "half_day"
}
const _hoisted_13 = {
  key: 1,
  value: "custom"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Hours ")
const _hoisted_15 = {
  key: 0,
  class: "asterisk"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Minutes ")
const _hoisted_17 = {
  key: 0,
  class: "asterisk"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("label", null, "Employee Comment", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("label", null, "Supervisor Comment", -1)
const _hoisted_20 = { class: "comment-name" }
const _hoisted_21 = {
  key: 3,
  class: "button-group"
}
const _hoisted_22 = {
  key: 4,
  class: "button-group"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_GroupContainer = _resolveComponent("GroupContainer")!

  return (_ctx.leaveItemData)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_GroupContainer, null, {
          default: _withId(() => [
            _createVNode("form", {
              class: "form-container",
              onSubmit: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["prevent"])),
              "aria-label": "review employee request"
            }, [
              _hoisted_3,
              _createVNode("input", {
                class: "date",
                type: "date",
                value: _ctx.formatDate(_ctx.leaveItemData.date),
                disabled: ""
              }, null, 8, ["value"]),
              _hoisted_4,
              _createVNode("p", _hoisted_5, [
                _createVNode("strong", null, _toDisplayString(_ctx.parseStatusTitle(_ctx.leaveItemData.status)), 1)
              ]),
              _createVNode("label", null, [
                _hoisted_6,
                (_ctx.leaveItemData.status === 'declined')
                  ? (_openBlock(), _createBlock("span", _hoisted_7, "*"))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.leaveItemData.type = $event)),
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.leaveChange())),
                disabled: _ctx.checkDisabled || _ctx.$route.name === 'Employee Leave Item'
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.leaveTypesData, (item, index) => {
                  return (_openBlock(), _createBlock("option", {
                    key: index,
                    value: item.type,
                    disabled: item.disable,
                    invalid: item.disable
                  }, _toDisplayString(item.display_title), 9, ["value", "disabled", "invalid"]))
                }), 128)),
                (_ctx.leaveItemData.type === 'workday')
                  ? (_openBlock(), _createBlock("option", _hoisted_8, "Workday"))
                  : _createCommentVNode("", true)
              ], 40, ["disabled"]), [
                [_vModelSelect, _ctx.leaveItemData.type]
              ]),
              _createVNode("label", null, [
                _hoisted_9,
                (_ctx.leaveItemData.status === 'declined')
                  ? (_openBlock(), _createBlock("span", _hoisted_10, "*"))
                  : _createCommentVNode("", true)
              ]),
              _withDirectives(_createVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.leaveItemData.duration_type = $event)),
                disabled: _ctx.checkDisabled || _ctx.$route.name === 'Employee Leave Item'
              }, [
                _hoisted_11,
                (_ctx.allowHalfDayType)
                  ? (_openBlock(), _createBlock("option", _hoisted_12, "Half Day"))
                  : _createCommentVNode("", true),
                (_ctx.allowCustomType)
                  ? (_openBlock(), _createBlock("option", _hoisted_13, "Custom"))
                  : _createCommentVNode("", true)
              ], 8, ["disabled"]), [
                [_vModelSelect, _ctx.leaveItemData.duration_type]
              ]),
              (_ctx.leaveItemData.duration_type === 'custom')
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode("label", null, [
                      _hoisted_14,
                      (_ctx.leaveItemData.status === 'declined')
                        ? (_openBlock(), _createBlock("span", _hoisted_15, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.durationHours.hours = $event)),
                      min: "0",
                      max: "24",
                      name: "hours",
                      type: "number",
                      step: "1",
                      onKeypress: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.wholeNumber && _ctx.wholeNumber(...args))),
                      disabled: _ctx.checkDisabled || _ctx.$route.name === 'Employee Leave Item',
                      required: ""
                    }, null, 40, ["disabled"]), [
                      [_vModelText, _ctx.durationHours.hours]
                    ]),
                    _createVNode("label", null, [
                      _hoisted_16,
                      (_ctx.leaveItemData.status === 'declined')
                        ? (_openBlock(), _createBlock("span", _hoisted_17, "*"))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createVNode("select", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.durationHours.minutes = $event)),
                      name: "minutes",
                      disabled: _ctx.checkDisabled || _ctx.$route.name === 'Employee Leave Item',
                      required: ""
                    }, [
                      (_openBlock(), _createBlock(_Fragment, null, _renderList([0, 15, 30, 45], (number, index) => {
                        return _createVNode("option", {
                          key: index,
                          value: number,
                          required: ""
                        }, _toDisplayString(number), 9, ["value"])
                      }), 64))
                    ], 8, ["disabled"]), [
                      [_vModelSelect, _ctx.durationHours.minutes]
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _hoisted_18,
              _withDirectives(_createVNode("textarea", {
                class: "comment",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.leaveItemData.submitter_comment = $event)),
                type: "text",
                placeholder: "",
                disabled: _ctx.checkDisabled || _ctx.$route.name === 'Employee Leave Item',
                maxlength: "512"
              }, null, 8, ["disabled"]), [
                [_vModelText, _ctx.leaveItemData.submitter_comment]
              ]),
              (
            (_ctx.leaveItemData.reviewer_comment
            || _ctx.$route.name == 'Employee Leave Item')
            && _ctx.leaveItemData.status !== 'conflict'
          )
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _hoisted_19,
                    _createVNode("span", _hoisted_20, _toDisplayString(_ctx.leaveItemData.reviewer_name), 1),
                    _withDirectives(_createVNode("textarea", {
                      class: "comment",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.leaveItemData.reviewer_comment = $event)),
                      type: "text",
                      placeholder: "",
                      disabled: 
              _ctx.checkDisabled
              && _ctx.$route.name !== 'Employee Leave Item'
              && _ctx.$route.name !== 'View/Edit User'
            
                    }, "\n          ", 8, ["disabled"]), [
                      [_vModelText, _ctx.leaveItemData.reviewer_comment]
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (
            _ctx.$route.name !== 'Employee Leave Item'
            && _ctx.$route.name !== 'View/Edit User'
            && (_ctx.leaveItemData.status === 'approved'
            || _ctx.leaveItemData.status === 'pending-approval')
          )
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 2,
                    text: "Withdraw",
                    type: "submit",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.withdrawRequest(_ctx.currentUUID, $event))),
                    async: true
                  }))
                : (
            _ctx.$route.name !== 'Employee Leave Item'
            && _ctx.leaveItemData.status === 'declined'
          )
                  ? (_openBlock(), _createBlock("div", _hoisted_21, [
                      _createVNode(_component_Button, {
                        text: "Delete",
                        type: "submit",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.deleteDeclined(_ctx.currentUUID, $event))),
                        async: true
                      }),
                      (_ctx.$route.name !== 'View/Edit User')
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            text: "Update",
                            type: "submit",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateRequest(_ctx.currentUUID, $event))),
                            async: true
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : (
            (_ctx.$route.name === 'Employee Leave Item'
            || _ctx.$route.name === 'View/Edit User')
            && _ctx.leaveItemData.status !== 'approved'
            && _ctx.leaveItemData.status !== 'declined'
            && _ctx.leaveItemData.status !== 'conflict'
          )
                    ? (_openBlock(), _createBlock("div", _hoisted_22, [
                        _createVNode(_component_Button, {
                          text: "Approve",
                          type: "submit",
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.approveRequest(_ctx.currentUUID, $event))),
                          async: true,
                          disabled: _ctx.isHRAdminReadOnly
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_Button, {
                          text: "Decline",
                          type: "submit",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.declineRequest(_ctx.currentUUID, $event))),
                          async: true,
                          disabled: _ctx.isHRAdminReadOnly
                        }, null, 8, ["disabled"])
                      ]))
                    : (
            (_ctx.$route.name === 'Employee Leave Item'
            || _ctx.$route.name === 'View/Edit User')
            && _ctx.leaveItemData.status === 'approved'
          )
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 5,
                          text: "Decline",
                          type: "submit",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.declineRequest(_ctx.currentUUID, $event))),
                          async: true,
                          disabled: _ctx.isHRAdminReadOnly
                        }, null, 8, ["disabled"]))
                      : (
            _ctx.$route.name === 'Leave Item'
            && _ctx.leaveItemData.status === 'conflict'
          )
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 6,
                            text: "Delete",
                            type: "submit",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.deleteDeclined(_ctx.currentUUID, $event))),
                            async: true,
                            disabled: _ctx.isHRAdminReadOnly
                          }, null, 8, ["disabled"]))
                        : _createCommentVNode("", true)
            ], 32)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
})